module.exports = __webpack_public_path__ + "static/media/Beep.0063e353.mp3";